<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Новый пользователь
            </div>
            <div class="content-inner" style="width: 50% !important;">

                    <div class="header-for-input first-input-header">Email пользователя</div>
                    <input type="text" v-model="user_data.email" class="content-input" />
                    <div class="header-for-input">Фамилия пользователя</div>
                    <input type="text" class="content-input" v-model="user_data.surname" />
                    <div class="header-for-input">Имя пользователя</div>
                    <input type="text" class="content-input" v-model="user_data.name" />
                    <div class="header-for-input">Отчество пользователя</div>
                    <input type="text" class="content-input" v-model="user_data.third_name" />
                    <div class="header-for-input">Роль пользователя</div>
                    <select class="content-input" v-model="user_data.role_id">
                        <option v-for="(role, role_id) in roles" :key="role_id" :value="role_id">{{role}}</option>
                    </select>
                    <div class="header-for-input">Телефон</div>
                    <input type="text" class="content-input" v-model="user_data.phone" />
                    <div class="header-for-input">Должность</div>
                    <input type="text" class="content-input" v-model="user_data.position" />

                    <br><br>

                    <div class="btn_main_button buttons_inline" @click="create()">Сохранить</div>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'NewUser',
    components: {
        Success, Error
    },
    mixins: [
        require('../../mixins/users/usersMixins.vue')
    ],
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            user_data: {
                email: '',
                surname: '',
                name: '',
                third_name: '',
                role_id: 0,
                position: '',
                phone: ''
            },
            roles: {
                0: 'Не выбрано',
                1: 'Администратор',
                2: 'Сборщик',
                4: 'Эксперт'
            }
        }
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>